import { render } from "./PersonalFonts.vue?vue&type=template&id=1cc1606e&scoped=true"
import script from "./PersonalFonts.vue?vue&type=script&lang=js"
export * from "./PersonalFonts.vue?vue&type=script&lang=js"

import "./PersonalFonts.vue?vue&type=style&index=0&id=1cc1606e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cc1606e"]])

export default __exports__